<template >
    <div class="mb-5">
        <slot>
        </slot>
        <br />
    </div>
</template>

<script>
export default {
    name: "FormSection",
    data() {
        return {};
    },
    props: {
    },
};
</script>

<style lang="scss" scoped>
</style>